import React, { ComponentProps } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

const InlineFields = ({ children, ...props }: ComponentProps<typeof Box>) => {
  if (!children) return null
  if (Array.isArray(children) && !children.some(Boolean)) return null

  return (
    <Box flexDirection="row" gap="s16" minWidth="s400" {...props}>
      {children}
    </Box>
  )
}

export default observer(InlineFields)
